var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home__background"},[(_vm.slides)?_c('Splide',{attrs:{"slides":_vm.slides}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }